/**
 * Loading page implementation.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var app  = require('mag-app'),
    keys = require('stb-keys'),

    Page   = require('stb-component-page'),
    List   = require('stb-component-list'),
    Button = require('stb-component-button'),

    FakeInput      = require('../components/fake.input'),

    accountManager = require('../modules/account.manager'),

    errorData  = {
        pmlInputLogin: {
            className: '',
            text: gettext('Please, input login')
        },
        pmlInputPassword: {
            className: 'passwordError',
            text: gettext('Please, input password')
        },
        pmlServerAddress: {
            className: 'addressError',
            text: gettext('Please, input portal address')
        },
        pmlInputActivateCode: {
            className: 'licenseError',
            text: gettext('Please, input valid license key')
        }
    },
    positions = {
        login: 1,
        password: 2,
        serverAddress: 3,
        licenseKey: 4,
        loginButton: 5
    },
    storageKey      = 'applications-storage',
    requestCallback = null,

    page, inputLogin, inputServerAddress, buttonSubmit,
    buttonNewAccount, inputPassword, inputActivateCode,
    accountList, buttonScrollUp, buttonScrollDown, accountsData;


//function declaration
function initCreateForm ( data, update ) {
    inputLogin.setValue(data.login);
    inputLogin.$node.classList.remove('error');
    inputPassword.setValue(data.password);
    inputPassword.$node.classList.remove('error');
    inputServerAddress.setValue(data.address);
    inputServerAddress.$node.classList.remove('error');
    inputActivateCode.setValue(data.activationCode);
    inputActivateCode.$node.classList.remove('error');

    if ( update ) {
        buttonSubmit.updateId = accountManager.get().indexOf(data);
        buttonSubmit.$text.innerHTML = gettext('Save');
        buttonSubmit.state = 'update';
    }
}


function updateAccountsCounter ( index ) {
    var length     = accountList.data.length,
        focusIndex = typeof index === 'undefined' ? (accountList.data.indexOf(accountList.$focusItem.data) + 1) : index + 1;

    window.pmlAccountListButtonScrollUp.innerText = focusIndex + '/' + length;
}


function loadTheme ( callback ) {
    var xhr = new XMLHttpRequest();

    xhr.open('GET', app.stalker.host + '/teratv_portal/server/api/launcher_profile.php?language=en&uid=' + app.stalker.session.userId);
    xhr.onload = function () {
        var config = null;

        console.log('config response text');

        try {
            config = JSON.parse(this.responseText);
        } catch ( error ) {
            console.log(error);
        }

        if ( config === null ) {
            // window.top.console.log('config is null');
            callback();
        } else if ( config.options && config.options.themePath ) {
            config.theme = {
                path: app.stalker.host + '/teratv_portal/server/api/theme_css.php?uid=' +
                app.stalker.session.userId + '&_=' + Date.now() + '&resolution=',
                vars: null
            };
            // xhr = new XMLHttpRequest();
            xhr.open('GET', config.theme.path + window.screen.height);

            xhr.onload = function () {
                window.top.console.log('onload theme ' + this.status);

                if ( this.status === 200 ) {
                    parent.extendCorePrototype('theme', config.theme);
                }
                callback();
            };

            xhr.onerror = xhr.ontimeout = function ( ) {
                console.log('onerror timeout ' + this.status);

                callback();
            };

            xhr.send();
        } else {
            console.log('no theme path');
            callback();
        }
    };

    xhr.onerror = xhr.ontimeout = function ( ) {
        // window.top.console.log('theme on error, on timeout');
        callback();
    };

    xhr.send();
}


function loadSettings ( globalOptions, callback ) {
    //window.top.sharedBackend = sharedBackend;
    console.log('USERS STORAGE');

    app.stalker.request('storage/' + storageKey, {
        onload: function ( error, data ) {
            console.log('APP STORAGE LAODED ' + JSON.stringify(data));

            if ( error ) {
                app.stalker.request('storage/', {
                    method: 'POST',
                    body: JSON.stringify({key: storageKey, value: '{}'})
                });
                window.storage = {};
            } else {
                window.storage = JSON.parse(data.data.value);
            }

            app.stalker.request('users/' + app.stalker.session.userId + '/settings', {
                onload: function ( error, settingsResponse ) {
                    var packages      = {},
                        sharedBackend = require('../modules/shared.backend');


                    core.config.apps.forEach(function ( appConfig ) {
                        if ( appConfig.type === 'app' ) {
                            packages[appConfig.packageName] = appConfig;

                            return true;
                        }

                        return false;
                    });

                    if ( !error && settingsResponse ) {
                        if ( PLATFORM === 'MAG' ) {
                            if ( settingsResponse.data.show_after_loading === 'last_channel' ) {
                                if ( packages['magcore-app-tv'] ) {
                                    core.taskManager.setHomeApp(packages['magcore-app-tv']);
                                }
                            }
                        }

                        app.parentPassword = settingsResponse.data.parent_password;
                        /* eslint max-len: 0 */
                        core.environment.audioPrimaryLanguage = settingsResponse.data.pri_audio_lang || settingsResponse.data.languages[0];
                        core.environment.audioSecondaryLanguage = settingsResponse.data.sec_audio_lang || settingsResponse.data.languages[1];
                        core.environment.subtitlesPrimaryLanguage = settingsResponse.data.pri_subtitle_lang || settingsResponse.data.languages[0];
                        core.environment.subtitlesSecondaryLanguage = settingsResponse.data.sec_subtitle_lang || settingsResponse.data.languages[1];

                        sharedBackend.instance.settings = settingsResponse.data;
                        parent.extendCorePrototype('environment', core.environment);

                        require('../modules/shared.backend').instance.emit('ready');
                    }
                    callback();
                },
                onerror: function ()  {
                    callback(true);
                },
                ontimeout: function ()  {
                    callback(true);
                }
            });
        },
        onerror: function ()  {
            callback(true);
        },
        ontimeout: function ()  {
            callback(true);
        }
    });

    parent.extendCorePrototype('Storage', require('../modules/storage'));
}


function loadModules ( callback ) {
    app.stalker.request('modules', {
        onload: function ( error, data ) {
            var map = {
                    // media_browser: 'media_browser',
                    'magcore-app-tv': 'tv',
                    // apps: 'apps',
                    // dvb: 'dvb',
                    // tv_archive: 'tv_archive',
                    // time_shift: 'time_shift',
                    // time_shift_local: 'time_shift_local',
                    // 'epg.reminder': 'epg.reminder',
                    // 'epg.recorder': 'epg.recorder',
                    // 'epg': 'epg',
                    // 'epg.simple': 'epg.simple',
                    'magcore-app-video-club': 'vclub',
                    'magcore-app-audio-club': 'audioclub',
                    'magcore-app-magic-cast': 'magiccast',
                    // 'downloads_dialog': 'downloads_dialog',
                    // 'downloads': 'downloads',
                    // 'karaoke': 'karaoke',
                    'magcore-app-radio': 'radio',
                    // 'weather.current': 'weather.current',
                    // 'widget.audio': 'widget.audio',
                    // 'widget.radio': 'widget.radio',
                    // 'records': 'records',
                    // 'remotepvr': 'remotepvr',
                    // 'pvr_local': 'pvr_local',
                    'magcore-app-settings': 'settings',
                    // 'course.nbu': 'course.nbu',
                    // 'weather.day': 'weather.day',
                    // 'cityinfo': 'cityinfo',
                    // 'horoscope': 'horoscope',
                    // 'anecdote': 'anecdote',
                    // 'game.mastermind': 'game.mastermind',
                    'magcore-app-personal-account': 'account'
                    // 'demo': 'demo',
                    // 'infoportal': 'infoportal',
                    // 'internet': 'internet',
                    // 'service_management': 'service_management',
                    // 'logout': 'logout',
                    // 'account_menu': 'account_menu'
                },
                originPackages   = core.packages,
                resolvedPackages = [];

            if ( !error && data ) {
                originPackages.forEach(function ( item ) {
                    var originName;

                    if ( item.type === 'app' ) {
                        originName = item.packageName.split('-');
                        // remove platform postfix
                        originName.pop();
                        originName = originName.join('-');
                        if ( data.data.indexOf(map[originName]) !== -1 ) {
                            resolvedPackages.push(item);
                        }
                    } else {
                        resolvedPackages.push(item);
                    }
                });
                core.updatePackages(resolvedPackages);
            }

            console.log('modules loaded and parsed');

            loadSettings(core.config.options, callback);
        },
        onerror: function ()  {
            console.log('loadModules onerror ');

            callback(true);
        },
        ontimeout: function ()  {
            console.log('loadModules ontimeout ');

            callback(true);
        }
    });
}


function login ( credentials, callback ) {
    window.pmlLabelError.innerText = '';
    window.pmlLabelError.className = '';
    inputLogin.$node.classList.remove('error');
    inputPassword.$node.classList.remove('error');
    inputServerAddress.$node.classList.remove('error');
    inputActivateCode.$node.classList.remove('error');
    app.stalker.auth.login(credentials, function ( error, response ) {
        window.top.console.log('login error: ' + error);
        if ( error ) {
            callback(error, response);
        } else {
            if ( requestCallback ) {
                requestCallback();
            }
            requestCallback = null;

            loadTheme(function ( error ) {
                if ( error ) {
                    callback(error);

                    return;
                }

                loadModules(function ( error ) {
                    if ( error ) {
                        callback(error);

                        return;
                    }

                    core.call('hide');
                    core.call('blur');

                    core.events['show'] = null;
                    core.emit('ready', {stop: false});
                    callback(null, response);
                });
            });
        }
    });
}


function preventedKeydown ( event ) {
    event.preventDefault();
}


function showApp ( callback ) {
    requestCallback = callback;
    core.emit('show');
    core.call('show');
    core.call('focus');
}


function errorNotification ( input ) {
    window.pmlLabelError.innerText = gettext('Error.') + ' ' + errorData[input.$node.id].text;
    window.pmlLabelError.className = 'visible ' + errorData[input.$node.id].className;
    input.focus();
    input.$node.classList.add('error');
    buttonSubmit.locked = false;
}


function setErrorPosition ( position ) {
    switch ( position ) {
        case positions.login:
            window.pmlLabelError.className = 'visible';
            inputLogin.$node.classList.add('error');
            inputPassword.$node.classList.add('error');
            inputLogin.focus();
            break;

        case positions.password:
            window.pmlLabelError.className = 'visible passwordError';
            inputLogin.$node.classList.add('error');
            inputPassword.$node.classList.add('error');
            inputLogin.focus();
            break;

        case positions.serverAddress:
            window.pmlLabelError.className = 'visible addressError';
            inputActivateCode.focus();
            inputActivateCode.$node.classList.add('error');
            break;

        case positions.licenseKey:
            window.pmlLabelError.className = 'visible licenseError';
            inputActivateCode.focus();
            inputActivateCode.$node.classList.add('error');
            break;

        case positions.loginButton:
            window.pmlLabelError.className = 'visible unknownError';
            break;
    }
}


function errorHandler ( code ) {
    switch ( code ) {
        case 'Username or password is incorrect':
            window.pmlLabelError.innerText = gettext('Incorrect login or password. Please try again');
            // inputLogin.focus();
            // inputLogin.$node.classList.add('error');
            // inputPassword.$node.classList.add('error');
            setErrorPosition(positions.login);
            break;

        case 'Activation code not found':
        case 'License key not found':
            window.pmlLabelError.innerText = gettext('License key not found');
            setErrorPosition(positions.licenseKey);
            break;

        case 'Operator ID mismatch':
            window.pmlLabelError.innerText = gettext('The License Key doesn\'t work for this portal. Please contact your Key provider.');
            setErrorPosition(positions.licenseKey);
            break;

        case 'Incorrect code. Please try again.':
        case 'Incorrect key. Please try again.':
            window.pmlLabelError.innerText = gettext('Incorrect key. Please try again.');
            setErrorPosition(positions.licenseKey);
            break;

        case 'Activation code missing':
        case 'License key missing':
            window.pmlLabelError.innerText = gettext('License key missing');
            setErrorPosition(positions.licenseKey);

            // window.pmlLabelError.className = 'visible licenseError';
            // inputActivateCode.focus();
            // inputActivateCode.$node.classList.add('error');
            break;

        case 'Meta data mismatch':
            window.pmlLabelError.innerText = gettext('The code you’ve entered has already been ' +
                'activated on another device. Please contact the code provider.');

            setErrorPosition(positions.licenseKey);
            break;

        case 'Reached limit the number of codes for user.':
            window.pmlLabelError.innerText = gettext('Reached limit the number of codes for user.');
            setErrorPosition(positions.licenseKey);
            break;

        case 'Certificate server error - unable to create certificate':
        case 'Unable to decode certificate server response':
            window.pmlLabelError.innerText = gettext('The license key has not been verified. Please contact your service provider.');
            setErrorPosition(positions.licenseKey);
            break;

        case 'Automatic activation code issuing disabled for user.':
            window.pmlLabelError.innerText = gettext('The license key has not been issued. Please contact your service provider.');
            setErrorPosition(positions.licenseKey);
            break;

        default:
            window.pmlLabelError.innerText = code || gettext('Error');
            setErrorPosition(positions.loginButton);
            break;
    }
}


function errorNetworkNotification ( interval ) {
    clearInterval(interval);
    window.pmlLabelError.innerText = gettext('No network connection');
    window.pmlLabelError.className = 'visible unknownError';
    buttonSubmit.locked = false;
}


//instance creation
page = new Page({
    focusable: false,
    $node: window.pageMultiLogin
});

inputLogin = new FakeInput({
    $node: window.pmlInputLogin,
    placeholder: gettext('Login'),
    // value: '6',
    events: {
        keydown: function ( event ) {
            FakeInput.defaultEvents.keydown.call(this, event);

            switch ( event.code ) {
                case keys.down:
                    this.$node.classList.remove('error');
                    inputPassword.$node.classList.remove('error');
                    inputPassword.focus();
                    window.pmlLabelError.innerText = '';
                    window.pmlLabelError.className = '';
                    break;

                default:
                    break;
            }
        }
    }
});

inputPassword = new FakeInput({
    $node: window.pmlInputPassword,
    placeholder: gettext('Password'),
    type: 'password',
    // value: '6',
    events: {
        keydown: function ( event ) {
            FakeInput.defaultEvents.keydown.call(this, event);

            switch ( event.code ) {
                case keys.down:
                    this.$node.classList.remove('error');
                    // if ( inputServerAddress.visible ) {
                    inputServerAddress.focus();
                    // } else {
                    //     buttonSubmit.focus();
                    // }
                    break;

                case keys.up:
                    this.$node.classList.remove('error');
                    inputLogin.focus();
                    break;

                default:
                    break;
            }
        }
    }
});

inputServerAddress = new FakeInput({
    $node: window.pmlServerAddress,
    placeholder: gettext('Portal'),
    scheme: 'http',
    // value: 'http://10.118.48.6',
    events: {
        keydown: function ( event ) {
            FakeInput.defaultEvents.keydown.call(this, event);

            switch ( event.code ) {
                case keys.down:
                    this.$node.classList.remove('error');
                    inputActivateCode.focus();
                    window.pmlLabelError.innerText = '';
                    window.pmlLabelError.className = '';
                    break;

                case keys.up:
                    this.$node.classList.remove('error');
                    inputPassword.focus();
                    break;

                default:
                    break;
            }
        }
    }
});

inputActivateCode = new FakeInput({
    $node: window.pmlInputActivateCode,
    placeholder: gettext('License key'),
    size: 12,
    // value: '123456789012',
    events: {
        keydown: function ( event ) {
            FakeInput.defaultEvents.keydown.call(this, event);

            switch ( event.code ) {
                case keys.down:
                    this.$node.classList.remove('error');
                    buttonSubmit.focus();
                    window.pmlLabelError.innerText = '';
                    window.pmlLabelError.className = '';
                    break;

                case keys.up:
                    this.$node.classList.remove('error');
                    inputServerAddress.focus();
                    break;

                default:
                    break;
            }
        }
    }
});

accountsData = accountManager.get();

accountList = new List({
    $node: window.pmlAccountList,
    type: List.prototype.TYPE_VERTICAL,
    size: accountsData.length < 3 ? accountsData.length : 3,
    focusIndex: 0,
    render: function ( $node, data ) {
        if ( !$node.ready ) {
            $node.$buttons = [];
            $node.$buttons.push($node.appendChild(document.createElement('div')));
            $node.$buttons[0].className = 'button account';

            $node.$nameContainer = $node.$buttons[0].appendChild(document.createElement('div'));
            $node.$nameContainer.className = 'name-container';

            $node.$nameContainer.appendChild(document.createElement('div'));
            $node.$nameContainer.firstChild.className = 'label';
            $node.$nameContainer.firstChild.innerText = gettext('Login');
            $node.$login = $node.$nameContainer.appendChild(document.createElement('div'));
            $node.$login.className = 'account';

            $node.$buttons[0].appendChild(document.createElement('div'));
            $node.$buttons[0].lastChild.className = 'theme-icon theme-icon-more';

            $node.$buttons.push($node.appendChild(document.createElement('div')));
            $node.lastChild.className = 'button edit';

            $node.$buttons.push($node.appendChild(document.createElement('div')));
            $node.lastChild.className = 'button remove';
            $node.ready = true;
        }

        $node.$login.innerText = data.login;
        $node.buttonFocusIndex = 0;
    },
    events: {
        overflow: function () {
            //if ( event.direction === keys.down ) {}
        },
        keydown: function ( event ) {
            var $node = this.$focusItem,
                index;

            switch ( event.code ) {
                case keys.right:
                    if ( $node.buttonFocusIndex < 2 ) {
                        $node.$buttons[$node.buttonFocusIndex].classList.remove('focus');
                        ++$node.buttonFocusIndex;
                        $node.$buttons[$node.buttonFocusIndex].classList.add('focus');
                    }
                    break;
                case keys.left:
                    if ( $node.buttonFocusIndex > 0 ) {
                        $node.$buttons[$node.buttonFocusIndex].classList.remove('focus');
                        --$node.buttonFocusIndex;
                        $node.$buttons[$node.buttonFocusIndex].classList.add('focus');
                    }
                    break;

                case keys.back:
                    window.top.platformApi.exit();
                    break;

                case keys.pageUp:
                case keys.pageDown:
                case keys.home:
                case keys.end:
                    // cursor move only on arrow keys
                    if ( PLATFORM === 'SMARTTV' ) {
                        document.body.style.display = 'none';
                        setTimeout(function () {
                            document.body.style.display = '';
                        }, 0);
                    }
                    this.move(event.code);
                    break;
                case keys.ok:
                    this.emit('click:item', {$item: $node, event: event});
                    break;

                case keys.up:
                    setTimeout(function () {
                        accountList.$node.style.opacity = '';
                    }, 0);
                    accountList.$node.style.opacity = '0.5';
                    index = this.data.indexOf($node.data);
                    if ( index > 0 ) {
                        if ( this.$focusItem === this.$body.firstChild && accountList.data.length > 3 ) {
                            buttonScrollUp.focus();
                            console.log('focus up button');
                        } else {
                            this.move(event.code);
                            updateAccountsCounter(index - 1);
                        }
                    }
                    break;

                case keys.down:
                    setTimeout(function () {
                        accountList.$node.style.opacity = '';
                    }, 0);
                    accountList.$node.style.opacity = '0.5';
                    index = this.data.indexOf($node.data);
                    if ( (index + 1) < this.data.length ) {
                        if ( index > 1 && accountList.data.length > 3 ) {
                            buttonScrollDown.focus();
                            console.log('focus down button');
                        } else {
                            updateAccountsCounter(index + 1);
                            this.move(event.code);
                        }
                    } else {
                        buttonNewAccount.focus();
                    }
            }
        },
        'focus:item': function ( event ) {
            console.log('focus item');
            if ( event.$prev ) {
                event.$prev.$buttons[1].style.display = 'none';
                event.$prev.$buttons[2].style.display = 'none';
                event.$prev.$buttons[event.$prev.buttonFocusIndex].classList.remove('focus');
            }

            event.$curr.buttonFocusIndex = 0;
            event.$curr.$buttons[event.$curr.buttonFocusIndex].classList.add('focus');
        },
        'click:item': function ( event ) {
            var self = this,
                focusIndex, viewIndex;

            if ( event.event && event.event.srcElement ) {
                // mouse click
                if ( event.event.srcElement === event.$item.$buttons[1] ) {
                    event.$item.buttonFocusIndex = 1;
                } else if ( event.event.srcElement === event.$item.$buttons[2] ) {
                    event.$item.buttonFocusIndex = 2;
                } else {
                    event.$item.buttonFocusIndex = 0;
                }
            }

            switch ( event.$item.buttonFocusIndex ) {
                case 0:
                    window.pmlAuthError.className = '';
                    if ( typeof window.navigator.onLine !== 'undefined' && !window.navigator.onLine ) {
                        window.pmlLabelError.innerText = gettext('No network connection');
                        window.pmlLabelError.className = 'visible';
                    } else {
                        login(event.$item.data, function ( error, response ) {
                            if ( error ) {
                                if ( error === 'onerror 0 : ' ) {
                                    window.pmlLabelError.innerText = gettext('Portal address entered incorrectly');
                                    window.pmlLabelError.className = 'visible addressError';
                                    inputServerAddress.focus();
                                    inputServerAddress.$node.classList.add('error');
                                } else if ( response && response.error_description ) {
                                    window.pmlAuthError.innerText = (response.error_description);
                                } else {
                                    window.pmlAuthError.innerText = gettext('Error');
                                }

                                if ( event.$item === self.$body.firstChild ) {
                                    window.pmlAuthError.className = 'visible';
                                } else if ( event.$item === self.$body.lastChild ) {
                                    window.pmlAuthError.className = 'visible third';
                                } else {
                                    window.pmlAuthError.className = 'visible second';
                                }
                            } else {
                                accountManager.get().indexOf(event.$item.data);
                                accountManager.update(event.$item.data);
                            }
                        });
                    }
                    break;

                case 1:
                    console.log('edit');
                    setTimeout(function () {
                        window.pmlAccountsContainer.className = 'hidden';
                        window.pmlLabelError.className = '';
                        window.pmlFormContainer.className = '';
                        inputLogin.focus();
                        initCreateForm(event.$item.data, true);
                    });
                    break;

                case 2:
                    console.log('remove');
                    focusIndex = this.$focusItem.index;
                    viewIndex = this.viewIndex;
                    console.log(focusIndex);
                    this.$focusItem.$buttons[this.$focusItem.buttonFocusIndex].classList.remove('focus');
                    this.$focusItem = this.viewIndex = null;
                    accountManager.remove(event.$item.data);
                    if ( this.size === 1 ) {
                        this.data = [];
                        window.pmlAccountsContainer.className = 'hidden';
                        window.pmlLabelError.className = '';
                        window.pmlFormContainer.className = '';
                        inputLogin.focus();
                    } else if ( this.data.length <= 3 ) {
                        --this.size;
                        this.init({
                            size: this.size,
                            viewIndex: viewIndex,
                            focusIndex: focusIndex,
                            data: accountManager.get()
                        });
                    } else {
                        this.init({
                            size: 3,
                            viewIndex: viewIndex,
                            focusIndex: focusIndex,
                            data: accountManager.get()
                        });
                    }
                    break;
            }
        }
    },
    data: accountsData
});

buttonSubmit = new Button({
    $node: window.pmlButtonSubmit,
    value: gettext('Login')
});

buttonNewAccount = new Button({
    $node: window.pmlAddAccount,
    value: gettext('Add account')
});

buttonScrollUp = new Button({
    $node: window.pmlAccountListButtonScrollUp,
    // className: '',
    events: {
        click: function () {
            if ( accountList.viewIndex > 0 ) {
                accountList.renderView(accountList.viewIndex - 1);
                updateAccountsCounter();
                if ( accountList.viewIndex === 0 ) {
                    accountList.focus();
                    buttonScrollUp.disabled = true;
                    buttonScrollUp.$node.className = 'transparent';
                } else {
                    buttonScrollDown.disabled = false;
                    buttonScrollDown.$node.className = '';
                }
            }
        },
        focus: function () {
            this.$node.className = 'focus';
        },
        blur: function () {
            this.$node.className = '';
        },
        keydown: function ( event ) {
            if ( event.code === keys.ok ) {
                this.emit('click');
            } else if ( event.code === keys.down ) {
                accountList.focus();
            }
        }
    }
});

buttonScrollDown = new Button({
    $node: window.pmlAccountListButtonScrollDown,
    // className: '',
    events: {
        click: function () {
            if ( accountList.data.length > (accountList.viewIndex + accountList.size) ) {
                accountList.renderView(accountList.viewIndex + 1);
                updateAccountsCounter();

                if ( (accountList.viewIndex + accountList.size) === accountList.data.length ) {
                    console.log(buttonScrollDown.$node.className);
                    accountList.focus();
                    buttonScrollDown.disabled = true;
                    buttonScrollDown.$node.className = 'transparent';
                }

                buttonScrollUp.disabled = false;
                buttonScrollUp.$node.className = '';
            }
        },
        focus: function () {
            this.$node.className = 'focus';
        },
        blur: function () {
            this.$node.className = '';
        },
        keydown: function ( event ) {
            if ( event.code === keys.ok ) {
                this.emit('click');
            } else if ( event.code === keys.up ) {
                accountList.focus();
            } else if ( event.code === keys.down ) {
                buttonNewAccount.focus();
            }
        }
    }
});

if ( accountList.data.length > 3 ) {
    buttonScrollDown.disabled = false;
    buttonScrollDown.$node.className = '';
} else {
    buttonScrollDown.disabled = true;
    buttonScrollDown.$node.className = 'transparent';
}

buttonScrollUp.disabled = true;
buttonScrollUp.$node.className = 'transparent';

inputLogin.title = gettext('Enter login');
inputPassword.title = gettext('Enter password');
inputServerAddress.title = gettext('Portal');
inputActivateCode.title = gettext('License key');
window.pmlFormDescription1.innerHTML = gettext('Request this information from your IPTV service provider');
window.pmlFormDescription2.innerHTML = gettext('Enter your License Key or buy a new one at <b>infomir.eu/pay</b>');

app.stalker.oncredenitalsrequired = function ( callback ) {
    var backend  = require('../modules/shared.backend').instance,
        accounts = accountManager.get(),
        session  = window.localStorage ? window.localStorage.getItem('ssession') : window.top.stbStorage.getItem('ssession');

    if ( session ) {
        try {
            session = JSON.parse(session);
        } catch ( exception ) {
            session = null;
        }
    }

    backend.withCredentials = true;

    // if ( backend.host ) {
    //     inputServerAddress.setValue(backend.host);
    //     window.pmlFormBlock.className = 'simple';
    //     inputServerAddress.hide();
    //     inputServerAddress.setValue(backend.host);
    //     inputActivateCode.hide();
    //     window.pmlFormDescription1.innerHTML = '';
    //     window.pmlFormDescription2.innerHTML = '';
    //     window.pmlFormDescription3.innerHTML = '';
    //     window.pmlLine.style.display = 'none';
    //     window.pmlLineSmall.style.display = 'none';
    //     buttonSubmit.$text.innerHTML = gettext('Login');

    //     window.pmlFormContainer.className = '';
    //     inputLogin.focus();
    // } else {
    //     window.pmlFormBlock.className = '';
    //     inputServerAddress.$node.classList.remove('hidden');
    //     inputActivateCode.$node.classList.remove('hidden');
    // }

    if ( session && accounts.length > 0 ) {
        accounts.forEach(function ( item, index ) {
            if ( item.latest ) {
                if ( typeof window.navigator.onLine !== 'undefined' && !window.navigator.onLine ) {
                    window.pmlAuthError.innerText = gettext('No network connection');
                    showApp(callback);

                    return;
                }

                login(item, function ( error, response ) {
                    if ( error ) {
                        if ( error === 'onerror 0 : ' ) {
                            window.pmlLabelError.innerText = gettext('Portal address entered incorrectly');
                            window.pmlLabelError.className = 'visible addressError';
                            inputServerAddress.focus();
                            inputServerAddress.$node.classList.add('error');
                        } else if ( response && response.error_description ) {
                            window.pmlAuthError.innerText = (response.error_description);
                        } else {
                            window.pmlAuthError.innerText = gettext('Error');
                        }

                        showApp(callback);
                    }
                });
            } else if ( index === accounts.length - 1 ) {
                showApp(callback);
            }
        });
    } else {
        showApp(callback);
    }
};

page.addListener('show', function () {
    var accounts = accountManager.get();

    if ( accounts.length > 0 ) {
        window.pmlAccountsContainer.className = '';
        accountList.focus();
        updateAccountsCounter(0);
    } else {
        window.pmlLabelError.className = '';
        window.pmlFormContainer.className = '';
        inputLogin.focus();

        if ( !app.licenseAgree ) {
            app.route(app.pages.eula);
        }
    }
});

page.addListener('keydown', function ( event ) {
    if ( event.code === keys.back /*&& buttonSubmit.state === 'update'*/ ) {
        if ( accountList.data.length ) {
            if ( page.activeComponent === accountList || page.activeComponent === buttonNewAccount ) {
                window.top.platformApi.exit();
            }
            buttonSubmit.state = null;
            buttonSubmit.$text.innerHTML = gettext('Add account');

            window.pmlFormContainer.className = 'hidden';
            window.pmlAccountsContainer.className = '';
            accountList.focus();
        } else {
            window.top.platformApi.exit();
        }
    }
    //  else if ( event.code === keys.f4 ) {
    //     app.route(app.pages.eula);
    // }
});

buttonNewAccount.addListener('click', function () {
    window.pmlAccountsContainer.className = 'hidden';
    window.pmlLabelError.className = '';
    window.pmlFormContainer.className = '';
    inputLogin.focus();
    window.pmlAuthError.className = '';
    initCreateForm({});
});

buttonNewAccount.addListener('keydown', function ( event ) {
    if ( event.code === keys.up ) {
        window.pmlAuthError.className = '';
        if ( buttonScrollDown.disabled ) {
            accountList.focus();
        } else {
            buttonScrollDown.focus();
        }
    }
});

buttonSubmit.addListener('keydown', function ( event ) {
    if ( event.code === keys.up ) {
        // if ( inputActivateCode.visible ) {
        inputActivateCode.focus();
        // } else {
        //     inputPassword.focus();
        // }
    }
});

buttonSubmit.addListener('click', function () {
    var submitInterval;

    if ( buttonSubmit.locked ) {
        return;
    }

    buttonSubmit.locked = true;

    if ( typeof window.navigator.onLine !== 'undefined' ) {
        submitInterval = setInterval(function () {
            if ( PLATFORM !== 'MAG' ) {
                if ( !window.navigator.onLine ) {
                    errorNetworkNotification(submitInterval);
                }
            }
        }, 5000);
    }

    // var backend = require('../modules/shared.backend').instance;

    // inputLogin.setValue('samsungdev');
    // inputServerAddress.setValue('http://smart-portal.infomir.com.ua/teratv_portal/');
    // inputPassword.setValue('4aijBoUGK5');
    // if ( DEVELOP ) {
    //     inputLogin.setValue('stv');
    //     inputPassword.setValue('1111');
    //     inputServerAddress.setValue('http://192.168.1.13/teratv_portal/');
    //     inputActivateCode.setValue('3110A46806C7');
    //     if ( PLATFORM === 'SMARTTV' ) {
    //         inputLogin.setValue('smart');
    //         inputPassword.setValue('1111');
    //         inputServerAddress.setValue('http://ad.h.od.ua/teratv_portal/');
    //         inputActivateCode.setValue('114073406EEB');
    //     }
    // }
    // reset style
    window.pmlLabelError.className = '';

    if ( inputLogin.value.length === 0 ) {
        // empty login
        errorNotification(inputLogin);
    } else if ( inputPassword.value.length === 0 ) {
        // empty password
        errorNotification(inputPassword);
    } else if ( inputServerAddress.value.length === 0 ) {
        // empty password
        errorNotification(inputServerAddress);
    } else if ( inputActivateCode.value.length !== 0 && inputActivateCode.value.length !== 12 ) {
        // empty password
        errorNotification(inputActivateCode);
    } else if ( PLATFORM !== 'MAG' && typeof window.navigator.onLine !== 'undefined' && !window.navigator.onLine ) {
        errorNetworkNotification(submitInterval);
    } else {
        login({
            password: inputPassword.value,
            login: inputLogin.value,
            address: inputServerAddress.value,
            activationCode: inputActivateCode.value
        }, function ( error, response ) {
            if ( typeof window.navigator.onLine !== 'undefined' ) {
                clearInterval(submitInterval);
            }

            buttonSubmit.locked = false;

            if ( error ) {
                console.log(JSON.stringify(error));
                console.log(typeof error.indexOf === 'function' && error.indexOf('404') !== -1);
                if ( error === 'onerror 0 : ' || error === '0 : ' ) {
                    window.pmlLabelError.innerText = gettext('Portal address entered incorrectly');
                    window.pmlLabelError.className = 'visible addressError';
                    inputServerAddress.focus();
                    inputServerAddress.$node.classList.add('error');
                } else if ( typeof error.indexOf === 'function' && error.indexOf('404') !== -1 ) {
                    window.pmlLabelError.innerText = gettext('Ministra Player is compatible only with the service of IPTV providers who use Stalker Middleware 5.2 or Ministra TV platform.');
                    window.pmlLabelError.className = 'visible addressError';
                    inputServerAddress.focus();
                    inputServerAddress.$node.classList.add('error');
                } else if ( response && response.error_description ) {
                    errorHandler(response.error_description);
                } else {
                    window.pmlLabelError.innerText = gettext('Error. Please try again.');
                    window.pmlLabelError.className = 'visible';
                }
            } else {
                if ( buttonSubmit.state === 'update' ) {
                    buttonSubmit.state = null;
                    accountManager.update({
                        password: inputPassword.value,
                        login: inputLogin.value,
                        address: inputServerAddress.value,
                        activationCode: inputActivateCode.value
                    }, buttonSubmit.updateId);
                } else {
                    if ( response.activation_code ) {
                        inputActivateCode.setValue(response.activation_code);
                    }

                    accountManager.add({
                        password: inputPassword.value,
                        login: inputLogin.value,
                        address: inputServerAddress.value,
                        activationCode: inputActivateCode.value
                    });
                }

                buttonSubmit.$text.innerHTML = gettext('Add account');
                window.pmlFormContainer.className = 'hidden';

                accountsData = accountManager.get();
                accountList.init({
                    size: accountsData.length < 3 ? accountsData.length : 3,
                    viewIndex: 0,
                    focusIndex: 0,
                    data: accountManager.get()
                });

                window.pmlAccountsContainer.className = '';
                accountList.focus();
            }
        });
    }
});

page.addListener('show', function () {
    window.addEventListener('keydown', preventedKeydown);
});

page.addListener('hide', function () {
    window.removeEventListener('keydown', preventedKeydown);
});


// public
module.exports = page;
